import Alt from 'alt/src/index';

var alt = new Alt();

export default alt;